// @ts-nocheck
import React from 'react';

export function FieldRequiredHint() {
  return <span class="required">*</span>;
}
